module.exports = __webpack_public_path__ + "static/media/Cart display_Sidecart.c9effcee.gif";